import React from 'react'
import {Spinner,Pane} from 'evergreen-ui'
import Logo from './../../assets/logo.svg'
import { useEffect } from 'react'
import {useHistory } from 'react-router-dom';

function LoadingPage() {
  const history = useHistory()


useEffect(() => {
  setTimeout(()=>{
    window.location.reload()
    // history.push('/dashboard')
  }, 5000);
}, [history])

  return (
    <div className='mt-100'>
        <div className='mt-100  center'>
            <img src={Logo} alt=''/>
        </div>
        <div className='row'>
          <div className='col s12  center '>
            <Pane display="flex" alignItems="center" justifyContent="center" height={100}>
              <Spinner />
            </Pane>
          </div>
          <div className='center'>
            <small>Please wait, setting up dashboard.</small>
          </div>

        </div>
    </div>
  )
}

export default LoadingPage